<app-form-element [control]="formControl" [id]="id" [label]="label" [required]="required" [twoColumns]="twoColumns">
  <p-datepicker
    [appendTo]="'body'"
    [defaultDate]="defaultDate"
    [formControl]="formControl"
    [id]="id"
    [maxDate]="internalMaxDate"
    [minDate]="internalMinDate"
    [showIcon]="true"
    [style]="{ width: '100%' }"
    [timeOnly]="timeOnly"
    dateFormat="dd.mm.yy"></p-datepicker>
</app-form-element>
